export default __webpack_public_path__ + "static/media/p2023-7.517d2ee4.jpeg";